/*
 * File: AppointmentDetailsPage.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays an appointment details page. Styles the view and section header/subheader.
 */
import React from "react";
import { observer } from "mobx-react";
import PatientCard from "../components/PatientCard";
import CurrentAppointmentDetailList from "../components/CurrentAppointmentDetailList";
import AppointmentLinks from "../components/AppointmentLinks";
import PropTypes from "prop-types";
import { withStyles, Toolbar } from "@material-ui/core";
import MainHeader from "components/MainHeader";
import { useStore } from "utils/useStore";
import ApptStore from "services/appointments/store/DataStore";

const styles = theme => ({
  toolbar: {
    padding: theme.spacing(2.5),
    display: "block",
    marginTop: theme.spacing(2.5),
    marginBottom: theme.spacing(2.5) //need extra spacing for the title 'Appointment Details' to remove overlap for smaller screens
  }
});

const AppointmentDetailsPage = ({ classes }) => {
  const appointmentStore = useStore(ApptStore);
  const selectedAppt = appointmentStore.selectedAppt;

  return (
    <React.Fragment>
      <Toolbar className={classes.toolbar}>
        <MainHeader pageTitle="Appointment Details" pageSubtitle="Schedule" />
      </Toolbar>
      <div className="padding">
        {selectedAppt && selectedAppt.appointmentId > 0 ? (
          <React.Fragment>
            <PatientCard patient={selectedAppt.patient} />
            <CurrentAppointmentDetailList appt={selectedAppt} />
            <AppointmentLinks appointmentId={selectedAppt.appointmentId} />
          </React.Fragment>
        ) : null}
      </div>
    </React.Fragment>
  );
};

export default withStyles(styles)(observer(AppointmentDetailsPage));

AppointmentDetailsPage.propTypes = {
  apptStore: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired
};
